var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-f31f5791": "",
    id: "HomeIcon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 668.8 668.9",
    xmlSpace: "preserve",
    className: "",
    width: 668.8,
    height: 668.9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-v-f31f5791": "",
    className: "sub_one"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-v-f31f5791": "",
    className: "st0",
    d: "M36.5,284c4.5-11.3,11.6-21.5,20.8-29.7l0.1-0.1l0.2-0.1L280.9,51.3c31.9-27.3,74.9-27.3,106.7,0L611.1,254l0.3,0.3l0.3,0.3c7.6,6.6,13.7,14.3,18.1,23.7l0.3,0.7c5,10.5,7.8,22.2,7.8,34v242.9c-2.8,49.4-37.9,82-79.8,82H110.6c-43,0-79.8-36.8-79.8-81.1V313C30.9,303.1,32.8,293.2,36.5,284L36.5,284z",
    stroke: "#909090",
    fill: "none",
    strokeWidth: "50px"
  })), /*#__PURE__*/React.createElement("path", {
    "data-v-f31f5791": "",
    className: "st1",
    d: "M637.9,311.7V500v55.9c-2.8,49.4-37.9,82-79.8,82H110.6c-43,0-79.8-36.8-79.8-81.1V313c0.1-9.9,2-19.8,5.7-29l0,0c4.5-11.3,11.6-21.5,20.8-29.7l0.1-0.1l0.2-0.1L280.9,51.3c31.9-27.3,74.9-27.3,106.7,0L611.1,254l0.3,0.3l0.3,0.3c7.6,6.6,13.7,14.3,18.1,23.7l0.3,0.7c4,8.4,6.9,17.6,7.8,27",
    style: {
      display: "block"
    },
    stroke: "#000000",
    fill: "none",
    strokeWidth: "63px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcon);
export default __webpack_public_path__ + "static/media/h-icon.59daf1abfab14dca8a131a70ed29f81b.svg";
export { ForwardRef as ReactComponent };